module.exports = __webpack_public_path__ + "img/collection-weddingRingsMen@2x.c3f7a2f.jpg";